module.exports = __webpack_public_path__ + "static/media/configuration.c695d60a.svg";